// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VenuesSelectionCard_card__\\+MV1N {
  position: relative;
  max-width: 100%;
  border-radius: 1rem;
  overflow: hidden;
  cursor: pointer;
  border: 5px solid var(--white);
  transition: all 0.2s ease;
  display: flex;
  flex: 0 0 auto;
}
.VenuesSelectionCard_card__\\+MV1N:hover {
  border: 5px solid #d1d5db;
}

.VenuesSelectionCard_selected__3Ag4q {
  border: 5px solid #3b82f6;
}

.VenuesSelectionCard_image__NzvMx {
  width: 100%;
  height: 100%;
  aspect-ratio: 245/368;
  max-width: 245px;
  object-fit: cover;
  object-position: center;
}
@media (max-width: 599px) {
  .VenuesSelectionCard_image__NzvMx {
    aspect-ratio: 205/328;
    max-width: 205px;
  }
}

.VenuesSelectionCard_badge__1AYJC {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #bcc7c0;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.VenuesSelectionCard_badgeSelected__O2k49 {
  background: #3b82f6;
  border-color: #3b82f6;
}

.VenuesSelectionCard_checkIcon__zjjck {
  width: 1rem;
  height: 1rem;
  color: #fff;
}

.VenuesSelectionCard_overlay__ewRK9 {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 80px;
  background: rgba(255, 255, 255, 0.6980392157);
  padding: 0.75rem 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 599px) {
  .VenuesSelectionCard_overlay__ewRK9 {
    height: 60px;
  }
}
.VenuesSelectionCard_overlay__ewRK9 h3 {
  font: var(--h3);
  font-family: var(--font-bodoni-72);
  font-weight: 700;
  color: var(--primary-Text);
}`, "",{"version":3,"sources":["webpack://./src/components/UserDashboard/VenuesSelectionCard/VenuesSelectionCard.module.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;AACD;AACC;EACC,yBAAA;AACF;;AAGA;EACC,yBAAA;AAAD;;AAGA;EACC,WAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAAD;AAEC;EARD;IASE,qBAAA;IACA,gBAAA;EACA;AACF;;AAEA;EACC,kBAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACD;;AAEA;EACC,mBAAA;EACA,qBAAA;AACD;;AAEA;EACC,WAAA;EACA,YAAA;EACA,WAAA;AACD;;AAEA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,6CAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACD;AACC;EAZD;IAaE,YAAA;EAEA;AACF;AAAC;EACC,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,0BAAA;AAEF","sourcesContent":[".card {\r\n\tposition: relative;\r\n\tmax-width: 100%;\r\n\tborder-radius: 1rem;\r\n\toverflow: hidden;\r\n\tcursor: pointer;\r\n\tborder: 5px solid var(--white);\r\n\ttransition: all 0.2s ease;\r\n\tdisplay: flex;\r\n\tflex: 0 0 auto;\r\n\r\n\t&:hover {\r\n\t\tborder: 5px solid #d1d5db;\r\n\t}\r\n}\r\n\r\n.selected {\r\n\tborder: 5px solid #3b82f6;\r\n}\r\n\r\n.image {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\taspect-ratio: 245 / 368;\r\n\tmax-width: 245px;\r\n\tobject-fit: cover;\r\n\tobject-position: center;\r\n\r\n\t@media (max-width: 599px) {\r\n\t\taspect-ratio: 205 / 328;\r\n\t\tmax-width: 205px;\r\n\t}\r\n}\r\n\r\n.badge {\r\n\tposition: absolute;\r\n\ttop: 0.5rem;\r\n\tright: 0.5rem;\r\n\twidth: 32px;\r\n\theight: 32px;\r\n\tborder-radius: 50%;\r\n\tborder: 2px solid #bcc7c0;\r\n\tbackground: #ffffff;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n}\r\n\r\n.badgeSelected {\r\n\tbackground: #3b82f6;\r\n\tborder-color: #3b82f6;\r\n}\r\n\r\n.checkIcon {\r\n\twidth: 1rem;\r\n\theight: 1rem;\r\n\tcolor: #fff;\r\n}\r\n\r\n.overlay {\r\n\tposition: absolute;\r\n\tbottom: 0;\r\n\twidth: 100%;\r\n\theight: 80px;\r\n\tbackground: #ffffffb2;\r\n\tpadding: 0.75rem 0;\r\n\ttext-align: center;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\r\n\t@media (max-width: 599px) {\r\n\t\theight: 60px;\r\n\t}\r\n\r\n\th3 {\r\n\t\tfont: var(--h3);\r\n\t\tfont-family: var(--font-bodoni-72);\r\n\t\tfont-weight: 700;\r\n\t\tcolor: var(--primary-Text);\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `VenuesSelectionCard_card__+MV1N`,
	"selected": `VenuesSelectionCard_selected__3Ag4q`,
	"image": `VenuesSelectionCard_image__NzvMx`,
	"badge": `VenuesSelectionCard_badge__1AYJC`,
	"badgeSelected": `VenuesSelectionCard_badgeSelected__O2k49`,
	"checkIcon": `VenuesSelectionCard_checkIcon__zjjck`,
	"overlay": `VenuesSelectionCard_overlay__ewRK9`
};
export default ___CSS_LOADER_EXPORT___;
